"use client"

import type React from "react"

import { toast } from "sonner"

type ToastProps = {
  title?: string
  description?: string
  variant?: "default" | "destructive"
  action?: React.ReactNode
  duration?: number
}

export function useToast() {
  const showToast = ({ title, description, variant, action, duration }: ToastProps) => {
    if (variant === "destructive") {
      return toast.error(title, {
        description,
        action,
        duration,
      })
    }

    return toast(title, {
      description,
      action,
      duration,
    })
  }

  return {
    toast: showToast,
  }
}

// Re-export toast from sonner for direct usage
export { toast }
